export const CreateBusinessCustomerUrl = '/api/emetro/v1/customer'
export const CreatePersonCustomerUrl = '/api/emetro/v1/kuka/customer'

export const BusinessInformationsUrl = '/api/emetro/v1/businessInformation/'
export const CheckPostalCodeUrl = '/api/emetro/v1/checkPostCode/'
